export const BOARD_SUMMARIES_LOAD = 'BOARD_SUMMARIES_LOAD';
export const BOARD_SUMMARIES_LOAD_ELEMENTS = 'BOARD_SUMMARIES_LOAD_ELEMENTS';
export const BOARD_SUMMARIES_REMOVE = 'BOARD_SUMMARIES_REMOVE';
